import apiClient from '../services/apiClient';
import store from './store'
import themeConfig from '../../themeConfig';

export default {
	namespaced: true,
	state: {
		initialized: false,
		name: '',
		subscriptionId: null,
		nextSubscriptionId: null,
		apiConnections: {
			accounting: {
				moneybird: false,
				eboekhouden: false,
			},
			shipping: {
				sendcloud: false,
			}
		},
		modules: {
			webshops: {
				lightspeed: false,
				bol: false,
			},
			accounting: {
				invoice: false,
			},
			inventory: {
				stockpool: false,
			},
		},
		layout: {
			color: {
				code: '#2C8DFB',
				custom: false,
			},
			mode: 'light',
			menuCollapse: false,
			topMenu: {
				color: '#FFFFFF',
				custom: false,
				type: 'floating'
			}
		},
		settings: {
			dropshippingEnabled: false
		},
		dashboardList: [],
	},
	getters: {
		initialized(state) {
			return state.initialized;
		},
		dashboard(state) {
			return state;
		},
		dashboardList(state) {
			return state.dashboardList;
		},
		sendCloudEnabled(state) {
			return state.apiConnections.shipping.sendcloud;
		},
		moneybirdEnabled(state) {
			return state.apiConnections.accounting.moneybird;
		},
		eboekhoudenEnabled(state) {
			return state.apiConnections.accounting.eboekhouden;
		},
		moduleInvoiceEnabled(state) {
			return state.modules.accounting.invoice;
		},
		moduleStockPoolsEnabled(state) {
			return state.modules.inventory.stockpool;
		},
	},
	mutations: {
		SET_DASHBOARD(state, dashboardData) {
			state.initialized = true;
			state.name = dashboardData.name;

			state.subscriptionId = dashboardData.subscription_id;
			state.nextSubscriptionId = dashboardData.next_subscription_id;

			state.apiConnections.accounting.moneybird = dashboardData.api_connections.accounting.moneybird;
			state.apiConnections.accounting.eboekhouden = dashboardData.api_connections.accounting.eboekhouden;
			state.apiConnections.shipping.sendcloud = dashboardData.api_connections.shipping.sendcloud;

			state.modules.accounting.invoice = dashboardData.modules.accounting.invoice;

			state.modules.inventory.stockpool = dashboardData.modules.inventory.stockpool;

			state.modules.webshops.lightspeed = dashboardData.modules.webshops.lightspeed;
			state.modules.webshops.bol = dashboardData.modules.webshops.bol;

			if (state.apiConnections.shipping.sendcloud) {
				store.dispatch('sendCloud/init');
			}

			state.layout.color.code = dashboardData.layout.color.code;
			state.layout.color.custom = dashboardData.layout.color.custom;
			state.layout.mode = dashboardData.layout.mode;
			state.layout.menuCollapse = dashboardData.layout.menu_collapse;
			state.layout.topMenu.color = dashboardData.layout.top_menu.color;
			state.layout.topMenu.custom = dashboardData.layout.top_menu.custom;
			state.layout.topMenu.type = dashboardData.layout.top_menu.type;

			state.settings.dropshippingEnabled = dashboardData.settings.dropshipping_enabled;
		},
		SET_DASHBOARD_LIST(state, dashboardListData) {
			state.dashboardList = [];

			dashboardListData.forEach((dashboardData) => {
				state.dashboardList.push({
					id: dashboardData.id,
					name: dashboardData.name,
					selected: dashboardData.selected,
				})
			})
		},
		SET_DASHBOARD_LAYOUT_COLOR(state, color) {
			if (state.layout.color.code !== color) {
				state.layout.color.code = color;
				state.layout.color.custom = !themeConfig.colorCodes.includes(color);

				this.dispatch('dashboard/updateLayoutSettings');
			}
		},
		SET_DASHBOARD_LAYOUT_MODE(state, mode) {
			if (state.layout.mode !== mode) {
				state.layout.mode = mode;

				this.dispatch('dashboard/updateLayoutSettings');
			}
		},
		SET_DASHBOARD_LAYOUT_MENU_COLLAPSE(state, menuCollapse) {
			if (state.layout.menuCollapse !== menuCollapse) {
				state.layout.menuCollapse = menuCollapse;

				this.dispatch('dashboard/updateLayoutSettings');
			}
		},
		SET_DASHBOARD_LAYOUT_TOP_MENU_COLOR(state, color) {
			if (state.layout.topMenu.color !== color) {
				state.layout.topMenu.color = color;
				state.layout.topMenu.custom = !themeConfig.colorCodes.includes(color);
				this.dispatch('dashboard/updateLayoutSettings');
			}
		},
		SET_DASHBOARD_LAYOUT_TOP_MENU_TYPE(state, type) {
			if (state.layout.topMenu.type !== type) {
				state.layout.topMenu.type = type;

				this.dispatch('dashboard/updateLayoutSettings');
			}
		},
		CLEAR_STORE(state) {
			state.initialized = false;
			state.name = '';
			state.subscriptionId = null;
			state.nextSubscriptionId = null;
			state.apiConnections.accounting.moneybird = false;
			state.apiConnections.accounting.eboekhouden = false;
			state.apiConnections.shipping.sendcloud = false;
			state.layout.color.code = '#2C8DFB';
			state.layout.color.custom = false;
			state.layout.mode = 'light';
			state.layout.menuCollapse = false;
			state.layout.topMenu.color = '#FFFFFF';
			state.layout.topMenu.custom = false;
			state.layout.topMenu.type = 'floating';
			state.settings.dropshippingEnabled = false;
		}
	},
	actions: {
		async init({commit, state}) {
			if (!state.initialized) {
				await apiClient.get('dashboard/selected').then(res => {
					commit('SET_DASHBOARD', res.data);
				}).catch(err => {
					console.error('Dashboard settings not found!');
				});

				await apiClient.get('dashboard/get').then(res => {
					commit('SET_DASHBOARD_LIST', res.data);
				}).catch(err => {
					console.error('Dashboard settings not found!');
				});
			}
		},
		async refresh({commit, state}) {
			await apiClient.get('dashboard/selected').then(res => {
				commit('SET_DASHBOARD', res.data);
			}).catch(err => {
				console.error('Dashboard settings not found!');
			});
		},
		async changeSelectedDashboard({commit}, dashboardId) {
			let params = {
				dashboard_id: dashboardId
			}

			await apiClient.put('dashboard/set', params).then(res => {
				commit('SET_DASHBOARD', res.data);

				apiClient.get('dashboard/get').then(res => {
					commit('SET_DASHBOARD_LIST', res.data);
				})
			})
		},
		async createDashboard({commit}, name) {
			let params = {
				name: name
			}

			await apiClient.post('dashboard/create', params).then(res => {
				commit('SET_DASHBOARD', res.data);

				apiClient.get('dashboard/get').then(res => {
					commit('SET_DASHBOARD_LIST', res.data);
				})
			})
		},
		async updateDashboard({commit}, payload) {
			let params = {
				dashboard_id: payload.dashboard_id,
				name: payload.name
			}

			await apiClient.put('dashboard/update', params).then(res => {
				commit('SET_DASHBOARD', res.data);

				apiClient.get('dashboard/get').then(res => {
					commit('SET_DASHBOARD_LIST', res.data);
				})
			})
		},
		async updateLayoutColor({commit}, color) {
			commit('SET_DASHBOARD_LAYOUT_COLOR', color);
		},
		async updateLayoutMode({commit}, mode) {
			commit('SET_DASHBOARD_LAYOUT_MODE', mode);
		},
		async updateLayoutMenuCollapse({commit}, mode) {
			commit('SET_DASHBOARD_LAYOUT_MENU_COLLAPSE', mode);
		},
		async updateLayoutTopMenuColor({commit}, mode) {
			commit('SET_DASHBOARD_LAYOUT_TOP_MENU_COLOR', mode);
		},
		async updateLayoutTopMenuType({commit}, mode) {
			commit('SET_DASHBOARD_LAYOUT_TOP_MENU_TYPE', mode);
		},
		async updateLayoutSettings({state}) {
			const params = {
				color: {
					code: state.layout.color.code,
					custom: state.layout.color.custom,
				},
				mode: state.layout.mode,
				menu_collapse: state.layout.menuCollapse,
				top_menu: {
					color: state.layout.topMenu.color,
					custom: state.layout.topMenu.custom,
					type: state.layout.topMenu.type,
				},
			};

			apiClient.put('dashboard/layout/set', params).then(response => {

			}).catch(err => {
				console.error('Layout settings not saved!');
			})
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}

